const authEs = {
  auth: {
    // Login
    login: {
      title: 'Iniciar Sesión',
      subtitle: 'Accede a tu cuenta',
      description: 'Ingresa tus credenciales para continuar',
      welcome: '¡Bienvenido de vuelta!',
      submitButton: 'Iniciar Sesión',
      loading: 'Iniciando sesión...',
      forgotPassword: '¿Olvidaste tu contraseña?',
      noAccount: '¿No tienes cuenta?',
      createAccount: 'Crear cuenta',
      orContinueWith: 'O continúa con',
      googleButton: 'Continuar con Google',
      googleLoading: 'Verificando con Google...',
    },

    // Logout
    logout: {
      button: 'Cerrar Sesión',
      loading: 'Cerrando sesión...',
      confirm: '¿Estás seguro de que quieres cerrar sesión?',
      success: 'Sesión cerrada correctamente',
    },

    // Forms
    form: {
      email: {
        label: 'Correo Electrónico',
        placeholder: 'tu@email.com',
      },
      password: {
        label: 'Contraseña',
        placeholder: 'Tu contraseña',
      },
      name: {
        label: 'Nombre Completo',
        placeholder: 'Tu nombre completo',
      },
      confirmPassword: {
        label: 'Confirmar Contraseña',
        placeholder: 'Confirma tu contraseña',
      },
      currentPassword: {
        label: 'Contraseña Actual',
        placeholder: 'Tu contraseña actual',
      },
      newPassword: {
        label: 'Nueva Contraseña',
        placeholder: 'Tu nueva contraseña',
      },
    },

    // Errors
    errors: {
      required: 'Este campo es requerido',
      email: 'El formato del email no es válido',
      passwordLength: 'La contraseña debe tener al menos 8 caracteres',
      passwordMatch: 'Las contraseñas no coinciden',
      userNotFound: 'Usuario no encontrado',
      wrongPassword: 'Contraseña incorrecta',
      invalidCredentials: 'Credenciales inválidas',
      emailTaken: 'Este email ya está registrado',
      genericError: 'Ha ocurrido un error. Inténtalo de nuevo.',
      networkError: 'Error de conexión. Verifica tu internet.',
      serverError: 'Error del servidor. Inténtalo más tarde.',
      loadUserDataTitle: 'Error al cargar datos del usuario',
      loadUserDataDescription:
        'No se pudieron cargar los datos de tu cuenta. Vuelve a intentarlo o inicia sesión de nuevo.',
      retryLogin: 'Volver a iniciar sesión',
      retryProfile: 'Reintentar',
    },

    // Success messages
    success: {
      loginSuccess: '¡Bienvenido de vuelta!',
      logoutSuccess: 'Sesión cerrada correctamente',
    },

    // Password Reset
    forgotPassword: {
      title: 'Recuperar Contraseña',
      description: 'Te enviaremos un enlace para restablecer tu contraseña',
      submitButton: 'Enviar Enlace',
      loading: 'Enviando enlace...',
      success: 'Enlace enviado. Revisa tu email.',
      backToLogin: 'Volver al login',
    },

    resetPassword: {
      title: 'Restablecer Contraseña',
      description: 'Ingresa tu nueva contraseña',
      submitButton: 'Restablecer',
      loading: 'Restableciendo...',
      success: 'Contraseña restablecida exitosamente',
    },

    // Email Verification
    emailVerification: {
      title: 'Verificar Email',
      description: 'Hemos enviado un enlace de verificación a tu email',
      resendButton: 'Reenviar Enlace',
      loading: 'Reenviando...',
      success: 'Enlace reenviado exitosamente',
      verified: 'Email verificado correctamente',
    },

    // Profile
    profile: {
      title: 'Mi Perfil',
      updateButton: 'Actualizar Perfil',
      loading: 'Actualizando...',
      changePassword: 'Cambiar Contraseña',
      changePasswordButton: 'Cambiar',
      loadingPassword: 'Cambiando contraseña...',
    },

    // Permissions
    permissions: {
      accessDenied: 'No tienes permisos para acceder a esta página',
      insufficientPermissions: 'Permisos insuficientes',
    },

    // Status
    status: {
      loading: 'Cargando...',
      authenticating: 'Autenticando...',
      redirecting: 'Redirigiendo...',
    },
  },
};

export default authEs;
